import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

// Render free plan gasi server nakon 15 min neaktivnosti, a pokretanje traje do ~1 min
const HEALTH_URL = 'https://project-wh-server.onrender.com/health';
// const HEALTH_URL = 'http://localhost:4000/health';

const PING_TIMEOUT_MS = 15000;
const RETRY_DELAY_MS = 3000;
const SLOW_AFTER_MS = 8000;
const MAX_WAIT_MS = 90000;

const serverSlice = createSlice({
    name: 'server',
    initialState: {
        status: 'checking', // 'checking' | 'ready' | 'error'
        isSlow: false,
    },
    reducers: {
        serverChecking: (state) => {
            state.status = 'checking';
            state.isSlow = false;
        },
        serverSlow: (state) => {
            state.isSlow = true;
        },
        serverReady: (state) => {
            state.status = 'ready';
            state.isSlow = false;
        },
        serverError: (state) => {
            state.status = 'error';
            state.isSlow = false;
        },
    },
});

let isWaking = false;

// Pinga server dok ne odgovori ili dok ne istekne MAX_WAIT_MS
export const wakeUpServer = () => async (dispatch) => {
    if (isWaking) return;
    isWaking = true;
    dispatch(serverChecking());

    const startedAt = Date.now();
    const slowTimer = setTimeout(() => dispatch(serverSlow()), SLOW_AFTER_MS);

    try {
        while (Date.now() - startedAt < MAX_WAIT_MS) {
            try {
                await axios.get(HEALTH_URL, { timeout: PING_TIMEOUT_MS });
                dispatch(serverReady());
                return;
            } catch (err) {
                await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
            }
        }
        dispatch(serverError());
    } finally {
        clearTimeout(slowTimer);
        isWaking = false;
    }
};

export const { serverChecking, serverSlow, serverReady, serverError } = serverSlice.actions;
export default serverSlice.reducer;
